export default "__VITE_ASSET__BDc7WS3h__"